import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zRolesViewAtts = z
  .record(zUid, zUid.array())
  .optional()
  .nullable();
